// extracted by mini-css-extract-plugin
module.exports = {"root":"Quotes_root__3Z9VX","light":"Quotes_light__38G3B","dark":"Quotes_dark__1fKIV"};